import type { ListFilter, ListRequest } from '@/api/generated/schemas';

import type { AsyncSearchParams, SortState } from '../types';

export function toSortParam(sort?: SortState): string | undefined {
  return sort ? `${sort.columnId}:${sort.direction}` : undefined;
}

export function omitEmptyQuery(query: string): string | undefined {
  return query || undefined;
}

export function toPagedSearchParams(params: AsyncSearchParams) {
  return {
    query: omitEmptyQuery(params.query),
    page: params.page,
    pageSize: params.pageSize,
    sort: toSortParam(params.sort),
  };
}

/** Rezervovaný klíč filtru pro resolve-by-ids (musí odpovídat BE selektor spec `EnumFilter("id")`). */
export const SELECTOR_ID_FIELD = 'id';

/**
 * Sestaví sjednocený list protokol (`ListRequest`) z parametrů selektoru — selektor je
 * „mini-listpage", BE používá tentýž `ListRequest`/`ListResponse` jako ListPage. Resolve-by-ids
 * se posílá jako filtr `"id"`; doménové filtry (např. sezóna) předá selektor v `extraFilters`.
 */
export function toListRequest(
  search: AsyncSearchParams | undefined,
  ids: readonly (string | number)[] | undefined,
  extraFilters: ListFilter[] = []
): ListRequest {
  const filters: ListFilter[] = [...extraFilters];
  if (ids && ids.length > 0) {
    filters.push({ field: SELECTOR_ID_FIELD, ids: ids.map((id) => String(id)) });
  }

  return {
    fulltext: search?.query?.trim() ? search.query.trim() : null,
    page: search?.page,
    pageSize: search?.pageSize,
    sort: search?.sort
      ? { column: search.sort.columnId, descending: search.sort.direction === 'desc' }
      : null,
    filters: filters.length > 0 ? filters : null,
  };
}

/** Stabilní React Query klíč selektorového dotazu (orval u POST negeneruje queryKey helper). */
export function listRequestQueryKey(routeKey: string, request: ListRequest): readonly unknown[] {
  return [routeKey, request];
}

export function nullToUndefined<T>(value: T | null): T | undefined {
  return value ?? undefined;
}
